"use client"
import { TeamName } from "@/app/pwa/components/team/TeamName";
import TeamImage from "@/app/pwa/components/TeamImage";
import { useTeam } from "@/app/pwa/lib/pwa-context";
import { Contest, Team } from "@/sources/kicker-amateur/types";
import { pwaTeamOpponentContestPath, pwaTeamPath } from "@/utils/urlHelper";
import Link from "next/link";

interface MatchTeamProps {
  teamId: number;
  team: Team;
  contest: Contest;
  position: "left" | "right";
  showBigIcons: boolean;
  linkToTeam?: boolean;
  teamTypeName?: boolean;
  size?: "base" | "lg"
  widget?: boolean
}

export function MatchTeamImp({
  team,
  teamId,
  contest,
  position,
  showBigIcons = true,
  teamTypeName,
  size,
}: MatchTeamProps) {
  return (
    <div
      className={`
        flex
        items-center
        group-[.size-lg]/match:-mt-px
        ${
          showBigIcons
            ? "flex-col @md/match:flex-row"
            : `${position === "left" ? "flex-row-reverse" : "flex-row"}`
        }
        ${position === "left" ? "@md/match:flex-row-reverse" : ""}
      `}
      // href={teamHref}
    >
      {team.Id && <TeamImage className="shrink-0" team={team} size={ size === "lg" ? "12" : (showBigIcons ? "10" : "8")} />}

      <h3
        className={`
            text-sm @lg:text-base
            group-[.size-lg]/match:text-base
            @lg:group-[.size-lg]/match:text-lg
            font-semibold @md/match:mx-2 
            text-center mt-1 @md/match:mt-0
            break-all
            @lg/match:overflow-hidden line-clamp-1 min-w-0
            ${
              position === "left"
                ? "@md/match:text-right"
                : "@md/match:text-left"
            }
          `}
      >
        <span className="@sm/match:hidden">
          <TeamName
            team={team}
            teamId={teamId}
            teamTypeName={teamTypeName}
            shortName
          />
        </span>
        <span className="hidden @sm/match:inline">
          <TeamName
            team={team}
            teamId={teamId}
            teamTypeName={teamTypeName}
          />
        </span>
      </h3>
    </div>
  );
}

export function MatchTeam({
  team,
  teamId,
  contest,
  position,
  showBigIcons = true,
  linkToTeam = false,
  teamTypeName,
  size,
  widget
}: MatchTeamProps) {
  const clubTeam = useTeam(team.Id!)

  const teamHref = clubTeam ? pwaTeamPath(`${team.Id}`): pwaTeamOpponentContestPath({
    team: team!,
    teamId: teamId.toString(),
    contest: contest,
  });

  if(widget){
    return (
      <div className="flex-1">
        <MatchTeamImp
          team={team}
          teamId={teamId}
          contest={contest}
          position={position}
          showBigIcons={showBigIcons}
          teamTypeName={teamTypeName}
          size={size}
        />
      </div>
    );
  } else if (linkToTeam) {
    return (
      <Link href={teamHref} className="flex-1">
        <MatchTeamImp
          team={team}
          teamId={teamId}
          contest={contest}
          position={position}
          showBigIcons={showBigIcons}
          teamTypeName={teamTypeName}
          size={size}
        />
      </Link>
    );
  } else {
    return (
      <div className="flex-1">
        <MatchTeamImp
          team={team}
          teamId={teamId}
          contest={contest}
          position={position}
          showBigIcons={showBigIcons}
          teamTypeName={teamTypeName}
          size={size}
        />
      </div>
    );
  }
}
